import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "section", "indicator"]

  spy() {
    const pageYPosition = document.documentElement.scrollTop

    this.sectionTargets.forEach(section => {
      const sectionYPosition = section.offsetTop

      if (pageYPosition > sectionYPosition - 60) {
        this.linkTargets.forEach((link) => {
          if (link.hash === `#${section.id}`) {
            this.indicatorTarget.style.setProperty("--scrollSpy-left", `${link.offsetLeft}px`)
            this.indicatorTarget.style.setProperty("--scrollSpy-width", `${link.offsetWidth}px`)
          }
        })
      }
    })
  }
}
